import React, { Component } from 'react'

import './render-count.scss'

export class RenderCount extends Component {
  renders = 0

  render() {
    return <div className="render-count">{++this.renders}</div>
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/render-count.tsx